// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ServiceOrders_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /customer-portal/v1/service-orders/get
 *
 * `order` belonging to the caller's document is enforced upstream — the
 * controller resolves the order via
 * portal_orders_model::getOrderForClientIds(), which returns null both when
 * the order does not exist and when it exists but belongs to a different
 * document, and either case ends in the SAME 404 `order_not_found` (no
 * oracle). This response is only ever built once that guard has passed.
 *
 * Field names are English per ADR-0014 §3 — only the three envelope keys
 * {success, dados, error} stay as they are.
 */
import type { Portal_ServiceOrders_ItemRow } from './Portal_ServiceOrders_ItemRow'
import type { Portal_ServiceOrders_OrderRow } from './Portal_ServiceOrders_OrderRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Portal_ServiceOrders_GetResponseDados {
order: Portal_ServiceOrders_OrderRow
items: Portal_ServiceOrders_ItemRow[]
}

export type Portal_ServiceOrders_GetResponse = ApiResponse<Portal_ServiceOrders_GetResponseDados>;

registerResponseContract('Portal_ServiceOrders_GetResponse', {
  order: {
    type: 'object',
    required: true,
    fields: {
      order_id:               { type: 'number',  required: true },
      franchise: {
        type: 'object',
        required: true,
        fields: {
          id:    { type: 'string',  required: true },
          name:  { type: 'string',  required: true },
          city:  { type: 'string',  required: false },
          state: { type: 'string',  required: false },
        },
      },
      status:                 { type: 'string',  required: true },
      created_at:             { type: 'string',  required: true },
      total_cents:            { type: 'number',  required: true },
      currency:               { type: 'string',  required: false },
      items_count:            { type: 'number',  required: true },
      delivered_items_count:  { type: 'number',  required: true },
      expected_delivery_at:   { type: 'string',  required: false },
      first_item_description: { type: 'string',  required: false },
      subtotal_cents:         { type: 'number',  required: false },
      payment: {
        type: 'object',
        required: true,
        fields: {
          total_cents: { type: 'number',  required: true },
          paid_cents:  { type: 'number',  required: true },
          status:      { type: 'string',  required: true },
        },
      },
    },
  },
  items: {
    type: 'array',
    required: true,
    items: {
      item_id:              { type: 'number',  required: true },
      parent_item_id:       { type: 'number',  required: false },
      type:                 { type: 'string',  required: true },
      description:          { type: 'string',  required: false },
      quantity:             { type: 'number',  required: true },
      unit_price_cents:     { type: 'number',  required: true },
      total_cents:          { type: 'number',  required: true },
      status:               { type: 'string',  required: true },
      expected_delivery_at: { type: 'string',  required: false },
      delivered_at:         { type: 'string',  required: false },
      qrcode:               { type: 'string',  required: false },
      steps: {
        type: 'array',
        required: false,
        items: {
          name:         { type: 'string',  required: true },
          position:     { type: 'number',  required: true },
          status:       { type: 'string',  required: true },
          started_at:   { type: 'string',  required: false },
          completed_at: { type: 'string',  required: false },
        },
      },
      reports: {
        type: 'object',
        required: true,
        fields: {
          entry: {
            type: 'object',
            required: false,
            fields: {
              report_id:    { type: 'number',  required: true },
              confirmed:    { type: 'boolean', required: true },
              confirmed_at: { type: 'string',  required: false },
              final_status: { type: 'string',  required: false },
            },
          },
          exit: {
            type: 'object',
            required: false,
            fields: {
              report_id:    { type: 'number',  required: true },
              confirmed:    { type: 'boolean', required: true },
              confirmed_at: { type: 'string',  required: false },
              final_status: { type: 'string',  required: false },
            },
          },
        },
      },
    },
  },
})
